export default {
  base: state => state.base,
  isLoading: state => state.isLoading,
  loginUser: state => state.loginUser,

  companies: state => state.companies,
  positions: state => state.positions,
  groups: state => state.groups,
  teams: state => state.teams,
  categories: state => state.categories,
  // jobs: state => state.jobs,
  services: state => state.services,
  members: state => state.members,
  membersWithAuthority: state => state.membersWithAuthority,
  logOfMemberWithAuthority: state => state.logOfMemberWithAuthority,
  selectedMember: state => state.selectedMember,
  // message
  messageToast: state => state.message.toast,
  messageAlert: state => state.message.alert,
  messageConfirm: state => state.message.confirm,
  messageNotification: state => state.message.notification,
};



// WEBPACK FOOTER //
// ./src/store/getter.js